import React, {Component} from 'react';
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {InputGroupAddon, Tooltip, Button} from "reactstrap";
import InputNumber from "components/InputNumber";
import classnames from "classnames";
import { connect } from 'react-redux';
import {setPlanRestrictionsModals} from "reducers/planRestrictionsModals/actions";
import QuestionSettingAvailable from "components/PlanRestrictionsModals/modals/QuestionSettingAvailable";
import moment from "moment";
import DatePicker from "react-datepicker";

class DateTimeMinDate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      question: {
        dateTimeMinDate: props.question.dateTimeMinDate,
      }
    };

    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  toggleTooltip(type) {
    this.setState({
      ...this.state,
      [type]: !this.state[type]
    })
  }

  onChange(value, target) {
    if (this.props.disabled) {
      this.props.setPlanRestrictionsModals(QuestionSettingAvailable.getName());
      return;
    }
    this.setState({
      ...this.state,
      question: {
        ...this.state.question,
        [target]: value
      }
    }, () => this.props.handleUpdate(this.state.question));
  }

  render() {
    const {question, tooltip} = this.state;
    const {id} = this.props.question;

    return (
      <React.Fragment>
        <div
          id={"dateTimeMinDate" + id}
          className={classnames({
            "min-w-0 float-left mr-1 mb-1 d-flex flex-nowrap input-group": true,
          })}
          style={{width: '125px'}}
        >
          <InputGroupAddon addonType="prepend">
            <Button
              className={classnames({
                "btn-icon": true,
                "active": !!question.dateTimeMinDate,
                "disabled": this.props.disabled
              })}
              color="secondary"
            >
              <i className="fak fa-sliders-simple-left"/>
              <Tooltip
                delay={0}
                placement="top"
                isOpen={tooltip}
                target={"dateTimeMinDate" + id}
                toggle={() => this.toggleTooltip('tooltip')}
              >Zakres daty od</Tooltip>
            </Button>
          </InputGroupAddon>
          <DatePicker
            className="mb-0 mt-1"
            isClearable={true}
            placeholderText={"Zakres daty od"}
            selected={question.dateTimeMinDate ? moment(question.dateTimeMinDate) : null}
            onChange={(date) => {
              this.onChange(date ? date.format('YYYY-MM-DD') : null, 'dateTimeMinDate')
            }}
            dateFormat={'Y-MM-DD'}
            locale={localStorage.language}
          />
        </div>
      </React.Fragment>
    )
  }
}

DateTimeMinDate.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    dateTimeMinDate: PropTypes.number.isRequired,
  }).isRequired,
  handleUpdate: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default connect(null, {setPlanRestrictionsModals})(DateTimeMinDate);
